import * as React from 'react';
import { useEffect } from 'react';
import { useOrgStore } from '../../../hooks/useOrgStore';
import { useAllowed } from '../../../hooks/useAllowed';
import { observer } from 'mobx-react';
import { CenterFormOrientation, CenterFormWidget } from '../../../widgets/layout/CenterFormWidget';
import { ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { useSystem } from '../../../hooks/useSystem';
import { useDialogStore } from '../../../hooks/useDialogService';
import { VCS_MODE } from '@journeyapps-platform/types-accounts-hub';
import styled from '@emotion/styled';
import { JourneyNavigationHandler, Routes } from '../../../routes';
import { getVersionControlMode } from '../../../utils/wording';
import { AppModelAction } from '@journeyapps-platform/cardinal-catalog';

export const ChangeSourceModeForm: React.FC<{ handler: JourneyNavigationHandler<Routes.APP_SOURCE_MODE> }> = observer(
  (props) => {
    const { params, navigate } = props.handler;
    const orgStore = useOrgStore();
    const system = useSystem();
    const dialogStore = useDialogStore();

    useEffect(() => {
      (async () => {
        const org = await orgStore.resolve(params.org_id);
        await org.getApp(params.app_id);
      })();
    }, []);

    // check for app
    let app = orgStore.org(params.org_id)?.app(params?.app_id);

    // not allowed
    const isAllowed = useAllowed({ action: AppModelAction.UPDATE, resource: app });
    if (!app || !isAllowed) {
      return null;
    }

    let switchToMode = app?.model.vcs_mode === VCS_MODE.ADVANCED ? VCS_MODE.BASIC : VCS_MODE.ADVANCED;

    return (
      <CenterFormWidget
        noLogo={true}
        primaryLabel="Change version control"
        secondaryLabel={app ? `App: ${app.model.name}` : ''}
        orientation={CenterFormOrientation.ROW}
      >
        <ButtonWidget
          label={`Change to ${getVersionControlMode(switchToMode)}`}
          action={async (event, loading) => {
            loading(true);
            const accounts = system.clientProvisioner.provisionAccountsV5Client();
            try {
              await accounts.updateApp({
                id: app!.id,
                vcs_mode: switchToMode
              });
              loading(false);
              orgStore.org(params.org_id!).loadApps();
              navigate(Routes.MANAGE_APPS, params);
            } catch (ex) {
              loading(false);
              dialogStore.errorDialog({
                subTitle: 'Failed to version control mode',
                errorMessage: `Oh no, something went wrong and this app couldn't updated`
              });
            }
          }}
        />
        <S.GoBack
          label="Go back"
          type={ButtonType.TERTIARY}
          action={async (event, loading) => {
            navigate(Routes.MANAGE_APPS, params);
          }}
        />
      </CenterFormWidget>
    );
  }
);

namespace S {
  export const GoBack = styled(ButtonWidget)`
    margin-top: 5px;
  `;
}
